import { message } from 'antd'
import {
  useAgentCustomerDrawer,
  useAppDispatch,
  useAppSelector
} from '../../../app/hooks'
import { fetchContacUsParams, reportContactUs } from '../../../actions/main'
import desktopLib from '../../../utils/desktopLib'

interface ContactUSOptions {
  /** 进线来源页面 */
  fromPage: string
  /** 是否直接打开人工客服，默认打开客服抽屉 */
  artificial?: boolean
  /** 人工客服渠道标识 */
  accessId?: string
  /** 调用入口的点击埋点 */
  track?: () => void
}

/**
 * 供联系客服按钮和照片王消息入口复用用户、团队参数及客服打开方式。
 * @param options - 客服渠道、来源及入口埋点
 * @returns 点击时调用的异步打开方法
 */
export function useContactUS({
  fromPage,
  artificial = false,
  accessId = 'fb4bf1ee-15ba-43b9-a0b4-fe6a56fc9514',
  track
}: ContactUSOptions) {
  const user = useAppSelector((state) => state.main.user)
  const group = useAppSelector((state) => state.group)
  const dispatch = useAppDispatch()
  const customerDrawer = useAgentCustomerDrawer()

  return async () => {
    track?.()
    // 必须在用户点击的同步阶段开窗，等待统计接口后再开会被浏览器拦截。
    const contactWindow =
      artificial && !desktopLib.isDesktop
        ? window.open(
            '',
            '_blank',
            `width=500,height=600,left=${(window.screen.availWidth - 500) / 2},top=${(window.screen.availHeight - 600) / 2}`
          )
        : null
    if (artificial && !desktopLib.isDesktop && !contactWindow) {
      message.warning('请允许浏览器弹出窗口后重试')
      return
    }
    if (contactWindow) contactWindow.opener = null
    void dispatch(reportContactUs()).catch(() => undefined)

    const visitorExtraInfo: Record<
      string,
      string | number | boolean | undefined
    > = {
      版本号: desktopLib.isDesktop ? desktopLib.clientInfo.version : '',
      来源页面: `${desktopLib.isDesktop ? 'PC端' : 'WEB端'}工作圈管理后台`,
      userid: user?.user_id,
      姓名: user?.nickname,
      登陆手机号: user?.mobile,
      团队名称: group.groupName,
      团队号: group.groupId,
      团队会员状态: group.isVip
    }
    try {
      const stat = await dispatch(fetchContacUsParams())
      visitorExtraInfo['个人会员历史充值次数'] = stat.userStats.orderRecordCount
      visitorExtraInfo['个人会员历史充值金额'] =
        stat.userStats.orderRecordSumAmount
      visitorExtraInfo['团队会员历史充值次数'] =
        stat.groupStats.orderRecordCount
      visitorExtraInfo['团队会员历史充值金额'] =
        stat.groupStats.orderRecordSumAmount
    } catch {
      // 辅助充值统计失败不应阻断联系客服。
    }

    const extraInfo = JSON.stringify(visitorExtraInfo)
    const query = {
      accessId,
      language: 'zh_CN',
      visitorId: user?.user_id,
      visitorName: user?.nickname,
      tel: user?.mobile,
      visitorExtraInfo: extraInfo,
      customerFields: extraInfo,
      fromPage
    }
    const qs = Object.entries(query)
      .map(
        ([key, value]) => `${key}=${encodeURIComponent(String(value || ''))}`
      )
      .join('&')
    if (artificial) {
      const contactUrl = `https://webchat-sh.clink.cn/chat.html?${qs}`
      if (desktopLib.isDesktop) desktopLib.openContact(contactUrl)
      else if (contactWindow && !contactWindow.closed)
        contactWindow.location.href = contactUrl
    } else {
      setTimeout(() => customerDrawer.open({ qs }), 100)
    }
  }
}
